import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartistModule } from 'ng-chartist';
import { CouponRoutingModule } from './coupon-routing.module';
import { CouponComponent } from './coupon.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QRCodeModule } from 'angularx-qrcode';
@NgModule({
  declarations: [CouponComponent],
  imports: [
    CommonModule,
    CouponRoutingModule,
    SharedModule,
    NgbModule,
    QRCodeModule,
    ChartistModule
  ]
})
export class InvoiceModule { }
